'use client';

/**
 * Skip Link Component
 * Provides a "Skip to main content" link for keyboard and screen reader users
 * Improves accessibility by allowing users to bypass navigation
 */

interface SkipLinkProps {
  targetId?: string;
  text?: string;
  className?: string;
}

export function SkipLink({
  targetId = 'main-content',
  text = 'Skip to main content',
  className = '',
}: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className={`
        skip-link
        absolute left-0 top-0 z-[9999]
        px-4 py-2 
        bg-blue-600 text-white
        font-medium text-sm
        rounded-br-md
        shadow-lg
        transform -translate-y-full
        focus:translate-y-0
        transition-transform duration-200
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        ${className}
      `}
      tabIndex={0}
    >
      {text}
    </a>
  );
}

/**
 * Main Content Wrapper
 * Wraps main content with proper ID for skip link target
 */

interface MainContentProps {
  children: React.ReactNode;
  id?: string;
  className?: string;
}

export function MainContent({
  children,
  id = 'main-content',
  className = '',
}: MainContentProps) {
  return (
    <main id={id} className={className} tabIndex={-1}>
      {children}
    </main>
  );
}

export default SkipLink;

